<template>
  <div class="layout-page">
     <bottom></bottom>
     <div class="full-screen">
        <div id="scroll-div-new" class="aui-scrollView main scroll-list" style=" padding-top: .3rem; z-index: 1; height: calc(100% - 50px);">

          <div class="movie-bn">
            <img style="width: 100%;" src="../../../assets/img/bn2.jpg">
          </div>

          <ul class="ul">
            <li v-for="(item, index) in categoryList" :key="item.id" :class="{ active: getCategoryActive === item.id }" @click="changeCategory(item.id)">{{ item.name }}</li>
          </ul>

          <books-large :show-title="false" :books="list"></books-large>

          <loading ref="loading" scroll-div="scroll-div-new" :is-loading="isLoading" :is-no-more-data="isNoMoreData"
                  @get-books="getBooks(currentPage + 1)"></loading>
          <div style="height: 2rem;"></div>
        </div>
    </div>
  </div>
</template>

<script>
import Bottom from '@/components/layer1/bottomIndex'
import BooksLarge from '@/components/novel/books-large'
import novelService from '@/services/novelService'
import Loading from "../../../components/share/loading";

export default {
  name: 'novel-new',
  data () {
    return {
      componentName: '',
      finished: false,
      finishedText: '',
      list: [],
      currentPage: 1,

      categoryList: [],
      selected: {
        category: 0,
        pageSize: 6,
      },
      todayUpdateBooks:[],
      todayUpdateCurrentPage: 0,
      isLoading: false,
      isNoMoreData: false,
      totalItem: 0,
    }
  },
  methods: {
    getBooks () {
      this.isLoading = true;
      this.isNoMoreData = false;
      const { finished, currentPage, list } = this
      if (finished) return
      let _category = ''
      if(this.selected.category === 0){
        _category = ''
      }else{
        _category = this.selected.category
      }
      novelService.getUpdateList(_category, 10, currentPage).then(res => {
        const resData = res.data
        const bookList = resData.novelBookList || []
        this.isLoading = false;
        this.list = list.concat(bookList)
        if (currentPage >= resData.totalPage || bookList.length === 0) {
          this.finished = true
          if (this.list.length > 6) {
            this.finishedText = '没有更多了'
          } else {
            this.finishedText = ''
          }
        } else {
          this.currentPage++
        }
      })
    },
    returnPage () {
      this.$router.isBack = true
      this.$router.go(-1)
    },
    returnHome () {
      this.$router.isBack = false
      this.$router.push('/home')
    },
    //获取分类
    getCategory () {
      novelService.getCategory().then(res => {
        this.categoryList = res.data.categoryList
      })
    },
     //换一批
     changeCategory(id) {
      this.selected.category = id;
      this.currentPage = 1
      this.getCategoryBooks(this.selected.category);
    },
    //请求下一批
    getCategoryBooks(category) {
      this.isLoading = true;
      this.isNoMoreData = false;
      this.list = [];
      let _category = category
      if (category === 0) {
        _category = ''
      }
      novelService.getUpdateList(_category, 10, 1)
        .then(res => {
          this.isLoading = false;
          if (res.result) {
            if (res.data.totalPage === 0) {
              this.list = [];
              this.isNoMoreData = true
            } else {
              this.list = res.data.novelBookList;
            }
            this.totalItem = res.data.totalItem;
          }
        })
    },
  },
  components: {
    swiper: Swiper,
    Bottom,
    'books-large': BooksLarge,
    loading: Loading,
  },
  computed: {
    getCategoryActive() {
      return this.selected.category
    }
  },
  mounted () {
    this.getCategory()
    this.getBooks()
    this.componentName = this.$route.name
    if (
      this.$store.state.pageState[this.componentName]
    ) {
      Object.assign(
        this.$data,
        this.$store.state.pageState[this.$route.name].data
      )
      setTimeout(() => {
        const scrollDiv = document.getElementById('scroll-div-new')
        scrollDiv.scrollTop = this.$store.state.pageState[this.$route.name].top
      }, 5)
    }
    this.$router.isBack = true
  },
  beforeDestroy () {
    const scrollDiv = document.getElementById('scroll-div-new')
    const state = {}
    state[this.componentName] = { data: this.$data, top: scrollDiv.scrollTop }
    this.$store.commit('saveState', state)
  }
}
</script>

<style scoped>

@import "../../../assets/css/novel.css";
.ul{ display: flex; margin:0 0 0.3rem 0; flex-direction: row; flex-wrap: wrap; text-align: center;justify-content: center; padding: .3rem;
background: #462e20; border-radius: 10px; margin: 10px;}
.ul li{ margin: 0.2rem 0.1rem 0.2rem 0.1rem;  text-align: center;font-size:.6rem; background: #ab5722; height: 1.4rem; line-height: 1.4rem;
    padding: 0; border-radius: .3rem; color: #fff;min-width: 3rem; border: 0px solid #b97500; text-align: center; width: 18.5%;}
.ul li.active{ background: #fff3eb; color: #C77241;}

.home-main-loading{position: fixed; background:#000 url(../../../assets/images/loading4.gif) center center no-repeat; background-size: 40px; 
    top: calc(50% - 60px); left: calc(50% - 60px); z-index: 2020; opacity: .7; width: 120px; height: 120px; border-radius: 10px;}



</style>



// WEBPACK FOOTER //
// src/pages/layer2/novels/new.vue